/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './app/routes/__root'
import { Route as SemEventoImport } from './app/routes/sem-evento'
import { Route as SplatImport } from './app/routes/$'
import { Route as EventRouteImport } from './app/routes/_event/route'
import { Route as EventIndexImport } from './app/routes/_event/index'
import { Route as EventSorteiosImport } from './app/routes/_event/sorteios'
import { Route as EventSignOutImport } from './app/routes/_event/sign-out'
import { Route as EventRankingImport } from './app/routes/_event/ranking'
import { Route as EventProgramacaoImport } from './app/routes/_event/programacao'
import { Route as EventMinhaContaImport } from './app/routes/_event/minha-conta'
import { Route as EventMeuPerfilImport } from './app/routes/_event/meu-perfil'
import { Route as EventMeuAvatarImport } from './app/routes/_event/meu-avatar'
import { Route as EventMedalhasImport } from './app/routes/_event/medalhas'
import { Route as EventExtratoDeRecompensasImport } from './app/routes/_event/extrato-de-recompensas'
import { Route as EventDuvidasFrequentesImport } from './app/routes/_event/duvidas-frequentes'
import { Route as EventConexoesImport } from './app/routes/_event/conexoes'
import { Route as EventBibliotecaImport } from './app/routes/_event/biblioteca'
import { Route as EventTransmissoesIndexImport } from './app/routes/_event/transmissoes/index'
import { Route as EventQuizzesIndexImport } from './app/routes/_event/quizzes/index'
import { Route as EventQuestsIndexImport } from './app/routes/_event/quests/index'
import { Route as EventParceirosIndexImport } from './app/routes/_event/parceiros/index'
import { Route as EventObjetivosIndexImport } from './app/routes/_event/objetivos/index'
import { Route as EventMissoesIndexImport } from './app/routes/_event/missoes/index'
import { Route as EventMinhaContaIndexImport } from './app/routes/_event/minha-conta/index'
import { Route as EventLojinhaIndexImport } from './app/routes/_event/lojinha/index'
import { Route as EventJornadasIndexImport } from './app/routes/_event/jornadas/index'
import { Route as EventFeedIndexImport } from './app/routes/_event/feed/index'
import { Route as EventTransmissoesLiveStreamIdImport } from './app/routes/_event/transmissoes/$liveStreamId'
import { Route as EventQuestsUidImport } from './app/routes/_event/quests/$uid'
import { Route as EventParceirosPartnerIdImport } from './app/routes/_event/parceiros/$partnerId'
import { Route as EventPRegrasImport } from './app/routes/_event/p/regras'
import { Route as EventPRealidadeAumentadaImport } from './app/routes/_event/p/realidade-aumentada'
import { Route as EventPRankingImport } from './app/routes/_event/p/ranking'
import { Route as EventPAnalyticsImport } from './app/routes/_event/p/analytics'
import { Route as EventPSlugImport } from './app/routes/_event/p/$slug'
import { Route as EventMinhaContaAvatarImport } from './app/routes/_event/minha-conta_.avatar'
import { Route as EventMinhaContaSegurancaImport } from './app/routes/_event/minha-conta/seguranca'
import { Route as EventMinhaContaPrivacidadeImport } from './app/routes/_event/minha-conta/privacidade'
import { Route as EventMinhaContaPerfilImport } from './app/routes/_event/minha-conta/perfil'
import { Route as EventMinhaContaNetworkingImport } from './app/routes/_event/minha-conta/networking'
import { Route as EventMinhaContaDesenvolvimentoImport } from './app/routes/_event/minha-conta/desenvolvimento'
import { Route as EventMinhaContaSplatImport } from './app/routes/_event/minha-conta/$'
import { Route as EventFeedNovaPublicacaoImport } from './app/routes/_event/feed/nova-publicacao'
import { Route as EventDevUiPrimitivesImport } from './app/routes/_event/dev/ui-primitives'
import { Route as EventConvitesCodeImport } from './app/routes/_event/convites/$code'
import { Route as EventBonusUidImport } from './app/routes/_event/bonus/$uid'
import { Route as EventAuthSignUpImport } from './app/routes/_event/auth/sign-up'
import { Route as EventAuthSignInImport } from './app/routes/_event/auth/sign-in'
import { Route as EventAuthResetPasswordImport } from './app/routes/_event/auth/reset-password'
import { Route as EventAuthResendConfirmationImport } from './app/routes/_event/auth/resend-confirmation'
import { Route as EventAuthRefreshSessionImport } from './app/routes/_event/auth/refresh-session'
import { Route as EventAuthForgotPasswordImport } from './app/routes/_event/auth/forgot-password'
import { Route as EventAuthErrorImport } from './app/routes/_event/auth/error'
import { Route as EventAuthConfirmationImport } from './app/routes/_event/auth/confirmation'
import { Route as EventEventSlugQuizzesImport } from './app/routes/_event/$eventSlug/quizzes'
import { Route as EventMissoesMissionIdIndexImport } from './app/routes/_event/missoes/$missionId/index'
import { Route as EventJornadasJourneyIdIndexImport } from './app/routes/_event/jornadas/$journeyId/index'
import { Route as EventEventSlugQuizzesIndexImport } from './app/routes/_event/$eventSlug/quizzes/index'
import { Route as EventEventSlugMissoesIndexImport } from './app/routes/_event/$eventSlug/missoes/index'
import { Route as EventEventSlugJornadasIndexImport } from './app/routes/_event/$eventSlug/jornadas/index'
import { Route as EventQuizzesQuizIdIniciarImport } from './app/routes/_event/quizzes/$quizId/iniciar'
import { Route as EventNiveisLevelIdIniciarImport } from './app/routes/_event/niveis/$levelId/iniciar'
import { Route as EventGuildsGuildIdEntrarImport } from './app/routes/_event/guilds/$guildId/entrar'
import { Route as EventEventSlugQuestsUidImport } from './app/routes/_event/$eventSlug/quests/$uid'
import { Route as EventEventSlugMissoesMissionIdIndexImport } from './app/routes/_event/$eventSlug/missoes/$missionId/index'
import { Route as EventEventSlugJornadasJourneyIdIndexImport } from './app/routes/_event/$eventSlug/jornadas/$journeyId/index'
import { Route as EventEventSlugQuizzesQuizIdIniciarImport } from './app/routes/_event/$eventSlug/quizzes/$quizId/iniciar'
import { Route as EventJornadasJourneyIdNiveisLevelIdIniciarImport } from './app/routes/_event/jornadas/$journeyId/niveis/$levelId/iniciar'

// Create/Update Routes

const SemEventoRoute = SemEventoImport.update({
  id: '/sem-evento',
  path: '/sem-evento',
  getParentRoute: () => rootRoute,
} as any)

const SplatRoute = SplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRoute,
} as any)

const EventRouteRoute = EventRouteImport.update({
  id: '/_event',
  getParentRoute: () => rootRoute,
} as any)

const EventIndexRoute = EventIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventSorteiosRoute = EventSorteiosImport.update({
  id: '/sorteios',
  path: '/sorteios',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventSignOutRoute = EventSignOutImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventRankingRoute = EventRankingImport.update({
  id: '/ranking',
  path: '/ranking',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventProgramacaoRoute = EventProgramacaoImport.update({
  id: '/programacao',
  path: '/programacao',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMinhaContaRoute = EventMinhaContaImport.update({
  id: '/minha-conta',
  path: '/minha-conta',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMeuPerfilRoute = EventMeuPerfilImport.update({
  id: '/meu-perfil',
  path: '/meu-perfil',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMeuAvatarRoute = EventMeuAvatarImport.update({
  id: '/meu-avatar',
  path: '/meu-avatar',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMedalhasRoute = EventMedalhasImport.update({
  id: '/medalhas',
  path: '/medalhas',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventExtratoDeRecompensasRoute = EventExtratoDeRecompensasImport.update({
  id: '/extrato-de-recompensas',
  path: '/extrato-de-recompensas',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventDuvidasFrequentesRoute = EventDuvidasFrequentesImport.update({
  id: '/duvidas-frequentes',
  path: '/duvidas-frequentes',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventConexoesRoute = EventConexoesImport.update({
  id: '/conexoes',
  path: '/conexoes',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventBibliotecaRoute = EventBibliotecaImport.update({
  id: '/biblioteca',
  path: '/biblioteca',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventTransmissoesIndexRoute = EventTransmissoesIndexImport.update({
  id: '/transmissoes/',
  path: '/transmissoes/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventQuizzesIndexRoute = EventQuizzesIndexImport.update({
  id: '/quizzes/',
  path: '/quizzes/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventQuestsIndexRoute = EventQuestsIndexImport.update({
  id: '/quests/',
  path: '/quests/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventParceirosIndexRoute = EventParceirosIndexImport.update({
  id: '/parceiros/',
  path: '/parceiros/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventObjetivosIndexRoute = EventObjetivosIndexImport.update({
  id: '/objetivos/',
  path: '/objetivos/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMissoesIndexRoute = EventMissoesIndexImport.update({
  id: '/missoes/',
  path: '/missoes/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMinhaContaIndexRoute = EventMinhaContaIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventMinhaContaRoute,
} as any)

const EventLojinhaIndexRoute = EventLojinhaIndexImport.update({
  id: '/lojinha/',
  path: '/lojinha/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventJornadasIndexRoute = EventJornadasIndexImport.update({
  id: '/jornadas/',
  path: '/jornadas/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventFeedIndexRoute = EventFeedIndexImport.update({
  id: '/feed/',
  path: '/feed/',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventTransmissoesLiveStreamIdRoute =
  EventTransmissoesLiveStreamIdImport.update({
    id: '/transmissoes/$liveStreamId',
    path: '/transmissoes/$liveStreamId',
    getParentRoute: () => EventRouteRoute,
  } as any)

const EventQuestsUidRoute = EventQuestsUidImport.update({
  id: '/quests/$uid',
  path: '/quests/$uid',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventParceirosPartnerIdRoute = EventParceirosPartnerIdImport.update({
  id: '/parceiros/$partnerId',
  path: '/parceiros/$partnerId',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventPRegrasRoute = EventPRegrasImport.update({
  id: '/p/regras',
  path: '/p/regras',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventPRealidadeAumentadaRoute = EventPRealidadeAumentadaImport.update({
  id: '/p/realidade-aumentada',
  path: '/p/realidade-aumentada',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventPRankingRoute = EventPRankingImport.update({
  id: '/p/ranking',
  path: '/p/ranking',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventPAnalyticsRoute = EventPAnalyticsImport.update({
  id: '/p/analytics',
  path: '/p/analytics',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventPSlugRoute = EventPSlugImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMinhaContaAvatarRoute = EventMinhaContaAvatarImport.update({
  id: '/minha-conta_/avatar',
  path: '/minha-conta/avatar',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMinhaContaSegurancaRoute = EventMinhaContaSegurancaImport.update({
  id: '/seguranca',
  path: '/seguranca',
  getParentRoute: () => EventMinhaContaRoute,
} as any)

const EventMinhaContaPrivacidadeRoute = EventMinhaContaPrivacidadeImport.update(
  {
    id: '/privacidade',
    path: '/privacidade',
    getParentRoute: () => EventMinhaContaRoute,
  } as any,
)

const EventMinhaContaPerfilRoute = EventMinhaContaPerfilImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => EventMinhaContaRoute,
} as any)

const EventMinhaContaNetworkingRoute = EventMinhaContaNetworkingImport.update({
  id: '/networking',
  path: '/networking',
  getParentRoute: () => EventMinhaContaRoute,
} as any)

const EventMinhaContaDesenvolvimentoRoute =
  EventMinhaContaDesenvolvimentoImport.update({
    id: '/desenvolvimento',
    path: '/desenvolvimento',
    getParentRoute: () => EventMinhaContaRoute,
  } as any)

const EventMinhaContaSplatRoute = EventMinhaContaSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => EventMinhaContaRoute,
} as any)

const EventFeedNovaPublicacaoRoute = EventFeedNovaPublicacaoImport.update({
  id: '/feed/nova-publicacao',
  path: '/feed/nova-publicacao',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventDevUiPrimitivesRoute = EventDevUiPrimitivesImport.update({
  id: '/dev/ui-primitives',
  path: '/dev/ui-primitives',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventConvitesCodeRoute = EventConvitesCodeImport.update({
  id: '/convites/$code',
  path: '/convites/$code',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventBonusUidRoute = EventBonusUidImport.update({
  id: '/bonus/$uid',
  path: '/bonus/$uid',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthSignUpRoute = EventAuthSignUpImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthSignInRoute = EventAuthSignInImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthResetPasswordRoute = EventAuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthResendConfirmationRoute =
  EventAuthResendConfirmationImport.update({
    id: '/auth/resend-confirmation',
    path: '/auth/resend-confirmation',
    getParentRoute: () => EventRouteRoute,
  } as any)

const EventAuthRefreshSessionRoute = EventAuthRefreshSessionImport.update({
  id: '/auth/refresh-session',
  path: '/auth/refresh-session',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthForgotPasswordRoute = EventAuthForgotPasswordImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthErrorRoute = EventAuthErrorImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventAuthConfirmationRoute = EventAuthConfirmationImport.update({
  id: '/auth/confirmation',
  path: '/auth/confirmation',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventEventSlugQuizzesRoute = EventEventSlugQuizzesImport.update({
  id: '/$eventSlug/quizzes',
  path: '/$eventSlug/quizzes',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventMissoesMissionIdIndexRoute = EventMissoesMissionIdIndexImport.update(
  {
    id: '/missoes/$missionId/',
    path: '/missoes/$missionId/',
    getParentRoute: () => EventRouteRoute,
  } as any,
)

const EventJornadasJourneyIdIndexRoute =
  EventJornadasJourneyIdIndexImport.update({
    id: '/jornadas/$journeyId/',
    path: '/jornadas/$journeyId/',
    getParentRoute: () => EventRouteRoute,
  } as any)

const EventEventSlugQuizzesIndexRoute = EventEventSlugQuizzesIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => EventEventSlugQuizzesRoute,
  } as any,
)

const EventEventSlugMissoesIndexRoute = EventEventSlugMissoesIndexImport.update(
  {
    id: '/$eventSlug/missoes/',
    path: '/$eventSlug/missoes/',
    getParentRoute: () => EventRouteRoute,
  } as any,
)

const EventEventSlugJornadasIndexRoute =
  EventEventSlugJornadasIndexImport.update({
    id: '/$eventSlug/jornadas/',
    path: '/$eventSlug/jornadas/',
    getParentRoute: () => EventRouteRoute,
  } as any)

const EventQuizzesQuizIdIniciarRoute = EventQuizzesQuizIdIniciarImport.update({
  id: '/quizzes/$quizId/iniciar',
  path: '/quizzes/$quizId/iniciar',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventNiveisLevelIdIniciarRoute = EventNiveisLevelIdIniciarImport.update({
  id: '/niveis/$levelId/iniciar',
  path: '/niveis/$levelId/iniciar',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventGuildsGuildIdEntrarRoute = EventGuildsGuildIdEntrarImport.update({
  id: '/guilds/$guildId/entrar',
  path: '/guilds/$guildId/entrar',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventEventSlugQuestsUidRoute = EventEventSlugQuestsUidImport.update({
  id: '/$eventSlug/quests/$uid',
  path: '/$eventSlug/quests/$uid',
  getParentRoute: () => EventRouteRoute,
} as any)

const EventEventSlugMissoesMissionIdIndexRoute =
  EventEventSlugMissoesMissionIdIndexImport.update({
    id: '/$eventSlug/missoes/$missionId/',
    path: '/$eventSlug/missoes/$missionId/',
    getParentRoute: () => EventRouteRoute,
  } as any)

const EventEventSlugJornadasJourneyIdIndexRoute =
  EventEventSlugJornadasJourneyIdIndexImport.update({
    id: '/$eventSlug/jornadas/$journeyId/',
    path: '/$eventSlug/jornadas/$journeyId/',
    getParentRoute: () => EventRouteRoute,
  } as any)

const EventEventSlugQuizzesQuizIdIniciarRoute =
  EventEventSlugQuizzesQuizIdIniciarImport.update({
    id: '/$quizId/iniciar',
    path: '/$quizId/iniciar',
    getParentRoute: () => EventEventSlugQuizzesRoute,
  } as any)

const EventJornadasJourneyIdNiveisLevelIdIniciarRoute =
  EventJornadasJourneyIdNiveisLevelIdIniciarImport.update({
    id: '/jornadas/$journeyId/niveis/$levelId/iniciar',
    path: '/jornadas/$journeyId/niveis/$levelId/iniciar',
    getParentRoute: () => EventRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_event': {
      id: '/_event'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof EventRouteImport
      parentRoute: typeof rootRoute
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatImport
      parentRoute: typeof rootRoute
    }
    '/sem-evento': {
      id: '/sem-evento'
      path: '/sem-evento'
      fullPath: '/sem-evento'
      preLoaderRoute: typeof SemEventoImport
      parentRoute: typeof rootRoute
    }
    '/_event/biblioteca': {
      id: '/_event/biblioteca'
      path: '/biblioteca'
      fullPath: '/biblioteca'
      preLoaderRoute: typeof EventBibliotecaImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/conexoes': {
      id: '/_event/conexoes'
      path: '/conexoes'
      fullPath: '/conexoes'
      preLoaderRoute: typeof EventConexoesImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/duvidas-frequentes': {
      id: '/_event/duvidas-frequentes'
      path: '/duvidas-frequentes'
      fullPath: '/duvidas-frequentes'
      preLoaderRoute: typeof EventDuvidasFrequentesImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/extrato-de-recompensas': {
      id: '/_event/extrato-de-recompensas'
      path: '/extrato-de-recompensas'
      fullPath: '/extrato-de-recompensas'
      preLoaderRoute: typeof EventExtratoDeRecompensasImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/medalhas': {
      id: '/_event/medalhas'
      path: '/medalhas'
      fullPath: '/medalhas'
      preLoaderRoute: typeof EventMedalhasImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/meu-avatar': {
      id: '/_event/meu-avatar'
      path: '/meu-avatar'
      fullPath: '/meu-avatar'
      preLoaderRoute: typeof EventMeuAvatarImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/meu-perfil': {
      id: '/_event/meu-perfil'
      path: '/meu-perfil'
      fullPath: '/meu-perfil'
      preLoaderRoute: typeof EventMeuPerfilImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/minha-conta': {
      id: '/_event/minha-conta'
      path: '/minha-conta'
      fullPath: '/minha-conta'
      preLoaderRoute: typeof EventMinhaContaImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/programacao': {
      id: '/_event/programacao'
      path: '/programacao'
      fullPath: '/programacao'
      preLoaderRoute: typeof EventProgramacaoImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/ranking': {
      id: '/_event/ranking'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof EventRankingImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/sign-out': {
      id: '/_event/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof EventSignOutImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/sorteios': {
      id: '/_event/sorteios'
      path: '/sorteios'
      fullPath: '/sorteios'
      preLoaderRoute: typeof EventSorteiosImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/': {
      id: '/_event/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof EventIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/quizzes': {
      id: '/_event/$eventSlug/quizzes'
      path: '/$eventSlug/quizzes'
      fullPath: '/$eventSlug/quizzes'
      preLoaderRoute: typeof EventEventSlugQuizzesImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/confirmation': {
      id: '/_event/auth/confirmation'
      path: '/auth/confirmation'
      fullPath: '/auth/confirmation'
      preLoaderRoute: typeof EventAuthConfirmationImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/error': {
      id: '/_event/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof EventAuthErrorImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/forgot-password': {
      id: '/_event/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof EventAuthForgotPasswordImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/refresh-session': {
      id: '/_event/auth/refresh-session'
      path: '/auth/refresh-session'
      fullPath: '/auth/refresh-session'
      preLoaderRoute: typeof EventAuthRefreshSessionImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/resend-confirmation': {
      id: '/_event/auth/resend-confirmation'
      path: '/auth/resend-confirmation'
      fullPath: '/auth/resend-confirmation'
      preLoaderRoute: typeof EventAuthResendConfirmationImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/reset-password': {
      id: '/_event/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof EventAuthResetPasswordImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/sign-in': {
      id: '/_event/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof EventAuthSignInImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/auth/sign-up': {
      id: '/_event/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof EventAuthSignUpImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/bonus/$uid': {
      id: '/_event/bonus/$uid'
      path: '/bonus/$uid'
      fullPath: '/bonus/$uid'
      preLoaderRoute: typeof EventBonusUidImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/convites/$code': {
      id: '/_event/convites/$code'
      path: '/convites/$code'
      fullPath: '/convites/$code'
      preLoaderRoute: typeof EventConvitesCodeImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/dev/ui-primitives': {
      id: '/_event/dev/ui-primitives'
      path: '/dev/ui-primitives'
      fullPath: '/dev/ui-primitives'
      preLoaderRoute: typeof EventDevUiPrimitivesImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/feed/nova-publicacao': {
      id: '/_event/feed/nova-publicacao'
      path: '/feed/nova-publicacao'
      fullPath: '/feed/nova-publicacao'
      preLoaderRoute: typeof EventFeedNovaPublicacaoImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/minha-conta/$': {
      id: '/_event/minha-conta/$'
      path: '/$'
      fullPath: '/minha-conta/$'
      preLoaderRoute: typeof EventMinhaContaSplatImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/minha-conta/desenvolvimento': {
      id: '/_event/minha-conta/desenvolvimento'
      path: '/desenvolvimento'
      fullPath: '/minha-conta/desenvolvimento'
      preLoaderRoute: typeof EventMinhaContaDesenvolvimentoImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/minha-conta/networking': {
      id: '/_event/minha-conta/networking'
      path: '/networking'
      fullPath: '/minha-conta/networking'
      preLoaderRoute: typeof EventMinhaContaNetworkingImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/minha-conta/perfil': {
      id: '/_event/minha-conta/perfil'
      path: '/perfil'
      fullPath: '/minha-conta/perfil'
      preLoaderRoute: typeof EventMinhaContaPerfilImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/minha-conta/privacidade': {
      id: '/_event/minha-conta/privacidade'
      path: '/privacidade'
      fullPath: '/minha-conta/privacidade'
      preLoaderRoute: typeof EventMinhaContaPrivacidadeImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/minha-conta/seguranca': {
      id: '/_event/minha-conta/seguranca'
      path: '/seguranca'
      fullPath: '/minha-conta/seguranca'
      preLoaderRoute: typeof EventMinhaContaSegurancaImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/minha-conta_/avatar': {
      id: '/_event/minha-conta_/avatar'
      path: '/minha-conta/avatar'
      fullPath: '/minha-conta/avatar'
      preLoaderRoute: typeof EventMinhaContaAvatarImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/p/$slug': {
      id: '/_event/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof EventPSlugImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/p/analytics': {
      id: '/_event/p/analytics'
      path: '/p/analytics'
      fullPath: '/p/analytics'
      preLoaderRoute: typeof EventPAnalyticsImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/p/ranking': {
      id: '/_event/p/ranking'
      path: '/p/ranking'
      fullPath: '/p/ranking'
      preLoaderRoute: typeof EventPRankingImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/p/realidade-aumentada': {
      id: '/_event/p/realidade-aumentada'
      path: '/p/realidade-aumentada'
      fullPath: '/p/realidade-aumentada'
      preLoaderRoute: typeof EventPRealidadeAumentadaImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/p/regras': {
      id: '/_event/p/regras'
      path: '/p/regras'
      fullPath: '/p/regras'
      preLoaderRoute: typeof EventPRegrasImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/parceiros/$partnerId': {
      id: '/_event/parceiros/$partnerId'
      path: '/parceiros/$partnerId'
      fullPath: '/parceiros/$partnerId'
      preLoaderRoute: typeof EventParceirosPartnerIdImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/quests/$uid': {
      id: '/_event/quests/$uid'
      path: '/quests/$uid'
      fullPath: '/quests/$uid'
      preLoaderRoute: typeof EventQuestsUidImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/transmissoes/$liveStreamId': {
      id: '/_event/transmissoes/$liveStreamId'
      path: '/transmissoes/$liveStreamId'
      fullPath: '/transmissoes/$liveStreamId'
      preLoaderRoute: typeof EventTransmissoesLiveStreamIdImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/feed/': {
      id: '/_event/feed/'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof EventFeedIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/jornadas/': {
      id: '/_event/jornadas/'
      path: '/jornadas'
      fullPath: '/jornadas'
      preLoaderRoute: typeof EventJornadasIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/lojinha/': {
      id: '/_event/lojinha/'
      path: '/lojinha'
      fullPath: '/lojinha'
      preLoaderRoute: typeof EventLojinhaIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/minha-conta/': {
      id: '/_event/minha-conta/'
      path: '/'
      fullPath: '/minha-conta/'
      preLoaderRoute: typeof EventMinhaContaIndexImport
      parentRoute: typeof EventMinhaContaImport
    }
    '/_event/missoes/': {
      id: '/_event/missoes/'
      path: '/missoes'
      fullPath: '/missoes'
      preLoaderRoute: typeof EventMissoesIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/objetivos/': {
      id: '/_event/objetivos/'
      path: '/objetivos'
      fullPath: '/objetivos'
      preLoaderRoute: typeof EventObjetivosIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/parceiros/': {
      id: '/_event/parceiros/'
      path: '/parceiros'
      fullPath: '/parceiros'
      preLoaderRoute: typeof EventParceirosIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/quests/': {
      id: '/_event/quests/'
      path: '/quests'
      fullPath: '/quests'
      preLoaderRoute: typeof EventQuestsIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/quizzes/': {
      id: '/_event/quizzes/'
      path: '/quizzes'
      fullPath: '/quizzes'
      preLoaderRoute: typeof EventQuizzesIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/transmissoes/': {
      id: '/_event/transmissoes/'
      path: '/transmissoes'
      fullPath: '/transmissoes'
      preLoaderRoute: typeof EventTransmissoesIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/quests/$uid': {
      id: '/_event/$eventSlug/quests/$uid'
      path: '/$eventSlug/quests/$uid'
      fullPath: '/$eventSlug/quests/$uid'
      preLoaderRoute: typeof EventEventSlugQuestsUidImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/guilds/$guildId/entrar': {
      id: '/_event/guilds/$guildId/entrar'
      path: '/guilds/$guildId/entrar'
      fullPath: '/guilds/$guildId/entrar'
      preLoaderRoute: typeof EventGuildsGuildIdEntrarImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/niveis/$levelId/iniciar': {
      id: '/_event/niveis/$levelId/iniciar'
      path: '/niveis/$levelId/iniciar'
      fullPath: '/niveis/$levelId/iniciar'
      preLoaderRoute: typeof EventNiveisLevelIdIniciarImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/quizzes/$quizId/iniciar': {
      id: '/_event/quizzes/$quizId/iniciar'
      path: '/quizzes/$quizId/iniciar'
      fullPath: '/quizzes/$quizId/iniciar'
      preLoaderRoute: typeof EventQuizzesQuizIdIniciarImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/jornadas/': {
      id: '/_event/$eventSlug/jornadas/'
      path: '/$eventSlug/jornadas'
      fullPath: '/$eventSlug/jornadas'
      preLoaderRoute: typeof EventEventSlugJornadasIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/missoes/': {
      id: '/_event/$eventSlug/missoes/'
      path: '/$eventSlug/missoes'
      fullPath: '/$eventSlug/missoes'
      preLoaderRoute: typeof EventEventSlugMissoesIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/quizzes/': {
      id: '/_event/$eventSlug/quizzes/'
      path: '/'
      fullPath: '/$eventSlug/quizzes/'
      preLoaderRoute: typeof EventEventSlugQuizzesIndexImport
      parentRoute: typeof EventEventSlugQuizzesImport
    }
    '/_event/jornadas/$journeyId/': {
      id: '/_event/jornadas/$journeyId/'
      path: '/jornadas/$journeyId'
      fullPath: '/jornadas/$journeyId'
      preLoaderRoute: typeof EventJornadasJourneyIdIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/missoes/$missionId/': {
      id: '/_event/missoes/$missionId/'
      path: '/missoes/$missionId'
      fullPath: '/missoes/$missionId'
      preLoaderRoute: typeof EventMissoesMissionIdIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/quizzes/$quizId/iniciar': {
      id: '/_event/$eventSlug/quizzes/$quizId/iniciar'
      path: '/$quizId/iniciar'
      fullPath: '/$eventSlug/quizzes/$quizId/iniciar'
      preLoaderRoute: typeof EventEventSlugQuizzesQuizIdIniciarImport
      parentRoute: typeof EventEventSlugQuizzesImport
    }
    '/_event/$eventSlug/jornadas/$journeyId/': {
      id: '/_event/$eventSlug/jornadas/$journeyId/'
      path: '/$eventSlug/jornadas/$journeyId'
      fullPath: '/$eventSlug/jornadas/$journeyId'
      preLoaderRoute: typeof EventEventSlugJornadasJourneyIdIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/$eventSlug/missoes/$missionId/': {
      id: '/_event/$eventSlug/missoes/$missionId/'
      path: '/$eventSlug/missoes/$missionId'
      fullPath: '/$eventSlug/missoes/$missionId'
      preLoaderRoute: typeof EventEventSlugMissoesMissionIdIndexImport
      parentRoute: typeof EventRouteImport
    }
    '/_event/jornadas/$journeyId/niveis/$levelId/iniciar': {
      id: '/_event/jornadas/$journeyId/niveis/$levelId/iniciar'
      path: '/jornadas/$journeyId/niveis/$levelId/iniciar'
      fullPath: '/jornadas/$journeyId/niveis/$levelId/iniciar'
      preLoaderRoute: typeof EventJornadasJourneyIdNiveisLevelIdIniciarImport
      parentRoute: typeof EventRouteImport
    }
  }
}

// Create and export the route tree

interface EventMinhaContaRouteChildren {
  EventMinhaContaSplatRoute: typeof EventMinhaContaSplatRoute
  EventMinhaContaDesenvolvimentoRoute: typeof EventMinhaContaDesenvolvimentoRoute
  EventMinhaContaNetworkingRoute: typeof EventMinhaContaNetworkingRoute
  EventMinhaContaPerfilRoute: typeof EventMinhaContaPerfilRoute
  EventMinhaContaPrivacidadeRoute: typeof EventMinhaContaPrivacidadeRoute
  EventMinhaContaSegurancaRoute: typeof EventMinhaContaSegurancaRoute
  EventMinhaContaIndexRoute: typeof EventMinhaContaIndexRoute
}

const EventMinhaContaRouteChildren: EventMinhaContaRouteChildren = {
  EventMinhaContaSplatRoute: EventMinhaContaSplatRoute,
  EventMinhaContaDesenvolvimentoRoute: EventMinhaContaDesenvolvimentoRoute,
  EventMinhaContaNetworkingRoute: EventMinhaContaNetworkingRoute,
  EventMinhaContaPerfilRoute: EventMinhaContaPerfilRoute,
  EventMinhaContaPrivacidadeRoute: EventMinhaContaPrivacidadeRoute,
  EventMinhaContaSegurancaRoute: EventMinhaContaSegurancaRoute,
  EventMinhaContaIndexRoute: EventMinhaContaIndexRoute,
}

const EventMinhaContaRouteWithChildren = EventMinhaContaRoute._addFileChildren(
  EventMinhaContaRouteChildren,
)

interface EventEventSlugQuizzesRouteChildren {
  EventEventSlugQuizzesIndexRoute: typeof EventEventSlugQuizzesIndexRoute
  EventEventSlugQuizzesQuizIdIniciarRoute: typeof EventEventSlugQuizzesQuizIdIniciarRoute
}

const EventEventSlugQuizzesRouteChildren: EventEventSlugQuizzesRouteChildren = {
  EventEventSlugQuizzesIndexRoute: EventEventSlugQuizzesIndexRoute,
  EventEventSlugQuizzesQuizIdIniciarRoute:
    EventEventSlugQuizzesQuizIdIniciarRoute,
}

const EventEventSlugQuizzesRouteWithChildren =
  EventEventSlugQuizzesRoute._addFileChildren(
    EventEventSlugQuizzesRouteChildren,
  )

interface EventRouteRouteChildren {
  EventBibliotecaRoute: typeof EventBibliotecaRoute
  EventConexoesRoute: typeof EventConexoesRoute
  EventDuvidasFrequentesRoute: typeof EventDuvidasFrequentesRoute
  EventExtratoDeRecompensasRoute: typeof EventExtratoDeRecompensasRoute
  EventMedalhasRoute: typeof EventMedalhasRoute
  EventMeuAvatarRoute: typeof EventMeuAvatarRoute
  EventMeuPerfilRoute: typeof EventMeuPerfilRoute
  EventMinhaContaRoute: typeof EventMinhaContaRouteWithChildren
  EventProgramacaoRoute: typeof EventProgramacaoRoute
  EventRankingRoute: typeof EventRankingRoute
  EventSignOutRoute: typeof EventSignOutRoute
  EventSorteiosRoute: typeof EventSorteiosRoute
  EventIndexRoute: typeof EventIndexRoute
  EventEventSlugQuizzesRoute: typeof EventEventSlugQuizzesRouteWithChildren
  EventAuthConfirmationRoute: typeof EventAuthConfirmationRoute
  EventAuthErrorRoute: typeof EventAuthErrorRoute
  EventAuthForgotPasswordRoute: typeof EventAuthForgotPasswordRoute
  EventAuthRefreshSessionRoute: typeof EventAuthRefreshSessionRoute
  EventAuthResendConfirmationRoute: typeof EventAuthResendConfirmationRoute
  EventAuthResetPasswordRoute: typeof EventAuthResetPasswordRoute
  EventAuthSignInRoute: typeof EventAuthSignInRoute
  EventAuthSignUpRoute: typeof EventAuthSignUpRoute
  EventBonusUidRoute: typeof EventBonusUidRoute
  EventConvitesCodeRoute: typeof EventConvitesCodeRoute
  EventDevUiPrimitivesRoute: typeof EventDevUiPrimitivesRoute
  EventFeedNovaPublicacaoRoute: typeof EventFeedNovaPublicacaoRoute
  EventMinhaContaAvatarRoute: typeof EventMinhaContaAvatarRoute
  EventPSlugRoute: typeof EventPSlugRoute
  EventPAnalyticsRoute: typeof EventPAnalyticsRoute
  EventPRankingRoute: typeof EventPRankingRoute
  EventPRealidadeAumentadaRoute: typeof EventPRealidadeAumentadaRoute
  EventPRegrasRoute: typeof EventPRegrasRoute
  EventParceirosPartnerIdRoute: typeof EventParceirosPartnerIdRoute
  EventQuestsUidRoute: typeof EventQuestsUidRoute
  EventTransmissoesLiveStreamIdRoute: typeof EventTransmissoesLiveStreamIdRoute
  EventFeedIndexRoute: typeof EventFeedIndexRoute
  EventJornadasIndexRoute: typeof EventJornadasIndexRoute
  EventLojinhaIndexRoute: typeof EventLojinhaIndexRoute
  EventMissoesIndexRoute: typeof EventMissoesIndexRoute
  EventObjetivosIndexRoute: typeof EventObjetivosIndexRoute
  EventParceirosIndexRoute: typeof EventParceirosIndexRoute
  EventQuestsIndexRoute: typeof EventQuestsIndexRoute
  EventQuizzesIndexRoute: typeof EventQuizzesIndexRoute
  EventTransmissoesIndexRoute: typeof EventTransmissoesIndexRoute
  EventEventSlugQuestsUidRoute: typeof EventEventSlugQuestsUidRoute
  EventGuildsGuildIdEntrarRoute: typeof EventGuildsGuildIdEntrarRoute
  EventNiveisLevelIdIniciarRoute: typeof EventNiveisLevelIdIniciarRoute
  EventQuizzesQuizIdIniciarRoute: typeof EventQuizzesQuizIdIniciarRoute
  EventEventSlugJornadasIndexRoute: typeof EventEventSlugJornadasIndexRoute
  EventEventSlugMissoesIndexRoute: typeof EventEventSlugMissoesIndexRoute
  EventJornadasJourneyIdIndexRoute: typeof EventJornadasJourneyIdIndexRoute
  EventMissoesMissionIdIndexRoute: typeof EventMissoesMissionIdIndexRoute
  EventEventSlugJornadasJourneyIdIndexRoute: typeof EventEventSlugJornadasJourneyIdIndexRoute
  EventEventSlugMissoesMissionIdIndexRoute: typeof EventEventSlugMissoesMissionIdIndexRoute
  EventJornadasJourneyIdNiveisLevelIdIniciarRoute: typeof EventJornadasJourneyIdNiveisLevelIdIniciarRoute
}

const EventRouteRouteChildren: EventRouteRouteChildren = {
  EventBibliotecaRoute: EventBibliotecaRoute,
  EventConexoesRoute: EventConexoesRoute,
  EventDuvidasFrequentesRoute: EventDuvidasFrequentesRoute,
  EventExtratoDeRecompensasRoute: EventExtratoDeRecompensasRoute,
  EventMedalhasRoute: EventMedalhasRoute,
  EventMeuAvatarRoute: EventMeuAvatarRoute,
  EventMeuPerfilRoute: EventMeuPerfilRoute,
  EventMinhaContaRoute: EventMinhaContaRouteWithChildren,
  EventProgramacaoRoute: EventProgramacaoRoute,
  EventRankingRoute: EventRankingRoute,
  EventSignOutRoute: EventSignOutRoute,
  EventSorteiosRoute: EventSorteiosRoute,
  EventIndexRoute: EventIndexRoute,
  EventEventSlugQuizzesRoute: EventEventSlugQuizzesRouteWithChildren,
  EventAuthConfirmationRoute: EventAuthConfirmationRoute,
  EventAuthErrorRoute: EventAuthErrorRoute,
  EventAuthForgotPasswordRoute: EventAuthForgotPasswordRoute,
  EventAuthRefreshSessionRoute: EventAuthRefreshSessionRoute,
  EventAuthResendConfirmationRoute: EventAuthResendConfirmationRoute,
  EventAuthResetPasswordRoute: EventAuthResetPasswordRoute,
  EventAuthSignInRoute: EventAuthSignInRoute,
  EventAuthSignUpRoute: EventAuthSignUpRoute,
  EventBonusUidRoute: EventBonusUidRoute,
  EventConvitesCodeRoute: EventConvitesCodeRoute,
  EventDevUiPrimitivesRoute: EventDevUiPrimitivesRoute,
  EventFeedNovaPublicacaoRoute: EventFeedNovaPublicacaoRoute,
  EventMinhaContaAvatarRoute: EventMinhaContaAvatarRoute,
  EventPSlugRoute: EventPSlugRoute,
  EventPAnalyticsRoute: EventPAnalyticsRoute,
  EventPRankingRoute: EventPRankingRoute,
  EventPRealidadeAumentadaRoute: EventPRealidadeAumentadaRoute,
  EventPRegrasRoute: EventPRegrasRoute,
  EventParceirosPartnerIdRoute: EventParceirosPartnerIdRoute,
  EventQuestsUidRoute: EventQuestsUidRoute,
  EventTransmissoesLiveStreamIdRoute: EventTransmissoesLiveStreamIdRoute,
  EventFeedIndexRoute: EventFeedIndexRoute,
  EventJornadasIndexRoute: EventJornadasIndexRoute,
  EventLojinhaIndexRoute: EventLojinhaIndexRoute,
  EventMissoesIndexRoute: EventMissoesIndexRoute,
  EventObjetivosIndexRoute: EventObjetivosIndexRoute,
  EventParceirosIndexRoute: EventParceirosIndexRoute,
  EventQuestsIndexRoute: EventQuestsIndexRoute,
  EventQuizzesIndexRoute: EventQuizzesIndexRoute,
  EventTransmissoesIndexRoute: EventTransmissoesIndexRoute,
  EventEventSlugQuestsUidRoute: EventEventSlugQuestsUidRoute,
  EventGuildsGuildIdEntrarRoute: EventGuildsGuildIdEntrarRoute,
  EventNiveisLevelIdIniciarRoute: EventNiveisLevelIdIniciarRoute,
  EventQuizzesQuizIdIniciarRoute: EventQuizzesQuizIdIniciarRoute,
  EventEventSlugJornadasIndexRoute: EventEventSlugJornadasIndexRoute,
  EventEventSlugMissoesIndexRoute: EventEventSlugMissoesIndexRoute,
  EventJornadasJourneyIdIndexRoute: EventJornadasJourneyIdIndexRoute,
  EventMissoesMissionIdIndexRoute: EventMissoesMissionIdIndexRoute,
  EventEventSlugJornadasJourneyIdIndexRoute:
    EventEventSlugJornadasJourneyIdIndexRoute,
  EventEventSlugMissoesMissionIdIndexRoute:
    EventEventSlugMissoesMissionIdIndexRoute,
  EventJornadasJourneyIdNiveisLevelIdIniciarRoute:
    EventJornadasJourneyIdNiveisLevelIdIniciarRoute,
}

const EventRouteRouteWithChildren = EventRouteRoute._addFileChildren(
  EventRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof EventRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/sem-evento': typeof SemEventoRoute
  '/biblioteca': typeof EventBibliotecaRoute
  '/conexoes': typeof EventConexoesRoute
  '/duvidas-frequentes': typeof EventDuvidasFrequentesRoute
  '/extrato-de-recompensas': typeof EventExtratoDeRecompensasRoute
  '/medalhas': typeof EventMedalhasRoute
  '/meu-avatar': typeof EventMeuAvatarRoute
  '/meu-perfil': typeof EventMeuPerfilRoute
  '/minha-conta': typeof EventMinhaContaRouteWithChildren
  '/programacao': typeof EventProgramacaoRoute
  '/ranking': typeof EventRankingRoute
  '/sign-out': typeof EventSignOutRoute
  '/sorteios': typeof EventSorteiosRoute
  '/': typeof EventIndexRoute
  '/$eventSlug/quizzes': typeof EventEventSlugQuizzesRouteWithChildren
  '/auth/confirmation': typeof EventAuthConfirmationRoute
  '/auth/error': typeof EventAuthErrorRoute
  '/auth/forgot-password': typeof EventAuthForgotPasswordRoute
  '/auth/refresh-session': typeof EventAuthRefreshSessionRoute
  '/auth/resend-confirmation': typeof EventAuthResendConfirmationRoute
  '/auth/reset-password': typeof EventAuthResetPasswordRoute
  '/auth/sign-in': typeof EventAuthSignInRoute
  '/auth/sign-up': typeof EventAuthSignUpRoute
  '/bonus/$uid': typeof EventBonusUidRoute
  '/convites/$code': typeof EventConvitesCodeRoute
  '/dev/ui-primitives': typeof EventDevUiPrimitivesRoute
  '/feed/nova-publicacao': typeof EventFeedNovaPublicacaoRoute
  '/minha-conta/$': typeof EventMinhaContaSplatRoute
  '/minha-conta/desenvolvimento': typeof EventMinhaContaDesenvolvimentoRoute
  '/minha-conta/networking': typeof EventMinhaContaNetworkingRoute
  '/minha-conta/perfil': typeof EventMinhaContaPerfilRoute
  '/minha-conta/privacidade': typeof EventMinhaContaPrivacidadeRoute
  '/minha-conta/seguranca': typeof EventMinhaContaSegurancaRoute
  '/minha-conta/avatar': typeof EventMinhaContaAvatarRoute
  '/p/$slug': typeof EventPSlugRoute
  '/p/analytics': typeof EventPAnalyticsRoute
  '/p/ranking': typeof EventPRankingRoute
  '/p/realidade-aumentada': typeof EventPRealidadeAumentadaRoute
  '/p/regras': typeof EventPRegrasRoute
  '/parceiros/$partnerId': typeof EventParceirosPartnerIdRoute
  '/quests/$uid': typeof EventQuestsUidRoute
  '/transmissoes/$liveStreamId': typeof EventTransmissoesLiveStreamIdRoute
  '/feed': typeof EventFeedIndexRoute
  '/jornadas': typeof EventJornadasIndexRoute
  '/lojinha': typeof EventLojinhaIndexRoute
  '/minha-conta/': typeof EventMinhaContaIndexRoute
  '/missoes': typeof EventMissoesIndexRoute
  '/objetivos': typeof EventObjetivosIndexRoute
  '/parceiros': typeof EventParceirosIndexRoute
  '/quests': typeof EventQuestsIndexRoute
  '/quizzes': typeof EventQuizzesIndexRoute
  '/transmissoes': typeof EventTransmissoesIndexRoute
  '/$eventSlug/quests/$uid': typeof EventEventSlugQuestsUidRoute
  '/guilds/$guildId/entrar': typeof EventGuildsGuildIdEntrarRoute
  '/niveis/$levelId/iniciar': typeof EventNiveisLevelIdIniciarRoute
  '/quizzes/$quizId/iniciar': typeof EventQuizzesQuizIdIniciarRoute
  '/$eventSlug/jornadas': typeof EventEventSlugJornadasIndexRoute
  '/$eventSlug/missoes': typeof EventEventSlugMissoesIndexRoute
  '/$eventSlug/quizzes/': typeof EventEventSlugQuizzesIndexRoute
  '/jornadas/$journeyId': typeof EventJornadasJourneyIdIndexRoute
  '/missoes/$missionId': typeof EventMissoesMissionIdIndexRoute
  '/$eventSlug/quizzes/$quizId/iniciar': typeof EventEventSlugQuizzesQuizIdIniciarRoute
  '/$eventSlug/jornadas/$journeyId': typeof EventEventSlugJornadasJourneyIdIndexRoute
  '/$eventSlug/missoes/$missionId': typeof EventEventSlugMissoesMissionIdIndexRoute
  '/jornadas/$journeyId/niveis/$levelId/iniciar': typeof EventJornadasJourneyIdNiveisLevelIdIniciarRoute
}

export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/sem-evento': typeof SemEventoRoute
  '/biblioteca': typeof EventBibliotecaRoute
  '/conexoes': typeof EventConexoesRoute
  '/duvidas-frequentes': typeof EventDuvidasFrequentesRoute
  '/extrato-de-recompensas': typeof EventExtratoDeRecompensasRoute
  '/medalhas': typeof EventMedalhasRoute
  '/meu-avatar': typeof EventMeuAvatarRoute
  '/meu-perfil': typeof EventMeuPerfilRoute
  '/programacao': typeof EventProgramacaoRoute
  '/ranking': typeof EventRankingRoute
  '/sign-out': typeof EventSignOutRoute
  '/sorteios': typeof EventSorteiosRoute
  '/': typeof EventIndexRoute
  '/auth/confirmation': typeof EventAuthConfirmationRoute
  '/auth/error': typeof EventAuthErrorRoute
  '/auth/forgot-password': typeof EventAuthForgotPasswordRoute
  '/auth/refresh-session': typeof EventAuthRefreshSessionRoute
  '/auth/resend-confirmation': typeof EventAuthResendConfirmationRoute
  '/auth/reset-password': typeof EventAuthResetPasswordRoute
  '/auth/sign-in': typeof EventAuthSignInRoute
  '/auth/sign-up': typeof EventAuthSignUpRoute
  '/bonus/$uid': typeof EventBonusUidRoute
  '/convites/$code': typeof EventConvitesCodeRoute
  '/dev/ui-primitives': typeof EventDevUiPrimitivesRoute
  '/feed/nova-publicacao': typeof EventFeedNovaPublicacaoRoute
  '/minha-conta/$': typeof EventMinhaContaSplatRoute
  '/minha-conta/desenvolvimento': typeof EventMinhaContaDesenvolvimentoRoute
  '/minha-conta/networking': typeof EventMinhaContaNetworkingRoute
  '/minha-conta/perfil': typeof EventMinhaContaPerfilRoute
  '/minha-conta/privacidade': typeof EventMinhaContaPrivacidadeRoute
  '/minha-conta/seguranca': typeof EventMinhaContaSegurancaRoute
  '/minha-conta/avatar': typeof EventMinhaContaAvatarRoute
  '/p/$slug': typeof EventPSlugRoute
  '/p/analytics': typeof EventPAnalyticsRoute
  '/p/ranking': typeof EventPRankingRoute
  '/p/realidade-aumentada': typeof EventPRealidadeAumentadaRoute
  '/p/regras': typeof EventPRegrasRoute
  '/parceiros/$partnerId': typeof EventParceirosPartnerIdRoute
  '/quests/$uid': typeof EventQuestsUidRoute
  '/transmissoes/$liveStreamId': typeof EventTransmissoesLiveStreamIdRoute
  '/feed': typeof EventFeedIndexRoute
  '/jornadas': typeof EventJornadasIndexRoute
  '/lojinha': typeof EventLojinhaIndexRoute
  '/minha-conta': typeof EventMinhaContaIndexRoute
  '/missoes': typeof EventMissoesIndexRoute
  '/objetivos': typeof EventObjetivosIndexRoute
  '/parceiros': typeof EventParceirosIndexRoute
  '/quests': typeof EventQuestsIndexRoute
  '/quizzes': typeof EventQuizzesIndexRoute
  '/transmissoes': typeof EventTransmissoesIndexRoute
  '/$eventSlug/quests/$uid': typeof EventEventSlugQuestsUidRoute
  '/guilds/$guildId/entrar': typeof EventGuildsGuildIdEntrarRoute
  '/niveis/$levelId/iniciar': typeof EventNiveisLevelIdIniciarRoute
  '/quizzes/$quizId/iniciar': typeof EventQuizzesQuizIdIniciarRoute
  '/$eventSlug/jornadas': typeof EventEventSlugJornadasIndexRoute
  '/$eventSlug/missoes': typeof EventEventSlugMissoesIndexRoute
  '/$eventSlug/quizzes': typeof EventEventSlugQuizzesIndexRoute
  '/jornadas/$journeyId': typeof EventJornadasJourneyIdIndexRoute
  '/missoes/$missionId': typeof EventMissoesMissionIdIndexRoute
  '/$eventSlug/quizzes/$quizId/iniciar': typeof EventEventSlugQuizzesQuizIdIniciarRoute
  '/$eventSlug/jornadas/$journeyId': typeof EventEventSlugJornadasJourneyIdIndexRoute
  '/$eventSlug/missoes/$missionId': typeof EventEventSlugMissoesMissionIdIndexRoute
  '/jornadas/$journeyId/niveis/$levelId/iniciar': typeof EventJornadasJourneyIdNiveisLevelIdIniciarRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_event': typeof EventRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/sem-evento': typeof SemEventoRoute
  '/_event/biblioteca': typeof EventBibliotecaRoute
  '/_event/conexoes': typeof EventConexoesRoute
  '/_event/duvidas-frequentes': typeof EventDuvidasFrequentesRoute
  '/_event/extrato-de-recompensas': typeof EventExtratoDeRecompensasRoute
  '/_event/medalhas': typeof EventMedalhasRoute
  '/_event/meu-avatar': typeof EventMeuAvatarRoute
  '/_event/meu-perfil': typeof EventMeuPerfilRoute
  '/_event/minha-conta': typeof EventMinhaContaRouteWithChildren
  '/_event/programacao': typeof EventProgramacaoRoute
  '/_event/ranking': typeof EventRankingRoute
  '/_event/sign-out': typeof EventSignOutRoute
  '/_event/sorteios': typeof EventSorteiosRoute
  '/_event/': typeof EventIndexRoute
  '/_event/$eventSlug/quizzes': typeof EventEventSlugQuizzesRouteWithChildren
  '/_event/auth/confirmation': typeof EventAuthConfirmationRoute
  '/_event/auth/error': typeof EventAuthErrorRoute
  '/_event/auth/forgot-password': typeof EventAuthForgotPasswordRoute
  '/_event/auth/refresh-session': typeof EventAuthRefreshSessionRoute
  '/_event/auth/resend-confirmation': typeof EventAuthResendConfirmationRoute
  '/_event/auth/reset-password': typeof EventAuthResetPasswordRoute
  '/_event/auth/sign-in': typeof EventAuthSignInRoute
  '/_event/auth/sign-up': typeof EventAuthSignUpRoute
  '/_event/bonus/$uid': typeof EventBonusUidRoute
  '/_event/convites/$code': typeof EventConvitesCodeRoute
  '/_event/dev/ui-primitives': typeof EventDevUiPrimitivesRoute
  '/_event/feed/nova-publicacao': typeof EventFeedNovaPublicacaoRoute
  '/_event/minha-conta/$': typeof EventMinhaContaSplatRoute
  '/_event/minha-conta/desenvolvimento': typeof EventMinhaContaDesenvolvimentoRoute
  '/_event/minha-conta/networking': typeof EventMinhaContaNetworkingRoute
  '/_event/minha-conta/perfil': typeof EventMinhaContaPerfilRoute
  '/_event/minha-conta/privacidade': typeof EventMinhaContaPrivacidadeRoute
  '/_event/minha-conta/seguranca': typeof EventMinhaContaSegurancaRoute
  '/_event/minha-conta_/avatar': typeof EventMinhaContaAvatarRoute
  '/_event/p/$slug': typeof EventPSlugRoute
  '/_event/p/analytics': typeof EventPAnalyticsRoute
  '/_event/p/ranking': typeof EventPRankingRoute
  '/_event/p/realidade-aumentada': typeof EventPRealidadeAumentadaRoute
  '/_event/p/regras': typeof EventPRegrasRoute
  '/_event/parceiros/$partnerId': typeof EventParceirosPartnerIdRoute
  '/_event/quests/$uid': typeof EventQuestsUidRoute
  '/_event/transmissoes/$liveStreamId': typeof EventTransmissoesLiveStreamIdRoute
  '/_event/feed/': typeof EventFeedIndexRoute
  '/_event/jornadas/': typeof EventJornadasIndexRoute
  '/_event/lojinha/': typeof EventLojinhaIndexRoute
  '/_event/minha-conta/': typeof EventMinhaContaIndexRoute
  '/_event/missoes/': typeof EventMissoesIndexRoute
  '/_event/objetivos/': typeof EventObjetivosIndexRoute
  '/_event/parceiros/': typeof EventParceirosIndexRoute
  '/_event/quests/': typeof EventQuestsIndexRoute
  '/_event/quizzes/': typeof EventQuizzesIndexRoute
  '/_event/transmissoes/': typeof EventTransmissoesIndexRoute
  '/_event/$eventSlug/quests/$uid': typeof EventEventSlugQuestsUidRoute
  '/_event/guilds/$guildId/entrar': typeof EventGuildsGuildIdEntrarRoute
  '/_event/niveis/$levelId/iniciar': typeof EventNiveisLevelIdIniciarRoute
  '/_event/quizzes/$quizId/iniciar': typeof EventQuizzesQuizIdIniciarRoute
  '/_event/$eventSlug/jornadas/': typeof EventEventSlugJornadasIndexRoute
  '/_event/$eventSlug/missoes/': typeof EventEventSlugMissoesIndexRoute
  '/_event/$eventSlug/quizzes/': typeof EventEventSlugQuizzesIndexRoute
  '/_event/jornadas/$journeyId/': typeof EventJornadasJourneyIdIndexRoute
  '/_event/missoes/$missionId/': typeof EventMissoesMissionIdIndexRoute
  '/_event/$eventSlug/quizzes/$quizId/iniciar': typeof EventEventSlugQuizzesQuizIdIniciarRoute
  '/_event/$eventSlug/jornadas/$journeyId/': typeof EventEventSlugJornadasJourneyIdIndexRoute
  '/_event/$eventSlug/missoes/$missionId/': typeof EventEventSlugMissoesMissionIdIndexRoute
  '/_event/jornadas/$journeyId/niveis/$levelId/iniciar': typeof EventJornadasJourneyIdNiveisLevelIdIniciarRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/$'
    | '/sem-evento'
    | '/biblioteca'
    | '/conexoes'
    | '/duvidas-frequentes'
    | '/extrato-de-recompensas'
    | '/medalhas'
    | '/meu-avatar'
    | '/meu-perfil'
    | '/minha-conta'
    | '/programacao'
    | '/ranking'
    | '/sign-out'
    | '/sorteios'
    | '/'
    | '/$eventSlug/quizzes'
    | '/auth/confirmation'
    | '/auth/error'
    | '/auth/forgot-password'
    | '/auth/refresh-session'
    | '/auth/resend-confirmation'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/bonus/$uid'
    | '/convites/$code'
    | '/dev/ui-primitives'
    | '/feed/nova-publicacao'
    | '/minha-conta/$'
    | '/minha-conta/desenvolvimento'
    | '/minha-conta/networking'
    | '/minha-conta/perfil'
    | '/minha-conta/privacidade'
    | '/minha-conta/seguranca'
    | '/minha-conta/avatar'
    | '/p/$slug'
    | '/p/analytics'
    | '/p/ranking'
    | '/p/realidade-aumentada'
    | '/p/regras'
    | '/parceiros/$partnerId'
    | '/quests/$uid'
    | '/transmissoes/$liveStreamId'
    | '/feed'
    | '/jornadas'
    | '/lojinha'
    | '/minha-conta/'
    | '/missoes'
    | '/objetivos'
    | '/parceiros'
    | '/quests'
    | '/quizzes'
    | '/transmissoes'
    | '/$eventSlug/quests/$uid'
    | '/guilds/$guildId/entrar'
    | '/niveis/$levelId/iniciar'
    | '/quizzes/$quizId/iniciar'
    | '/$eventSlug/jornadas'
    | '/$eventSlug/missoes'
    | '/$eventSlug/quizzes/'
    | '/jornadas/$journeyId'
    | '/missoes/$missionId'
    | '/$eventSlug/quizzes/$quizId/iniciar'
    | '/$eventSlug/jornadas/$journeyId'
    | '/$eventSlug/missoes/$missionId'
    | '/jornadas/$journeyId/niveis/$levelId/iniciar'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/sem-evento'
    | '/biblioteca'
    | '/conexoes'
    | '/duvidas-frequentes'
    | '/extrato-de-recompensas'
    | '/medalhas'
    | '/meu-avatar'
    | '/meu-perfil'
    | '/programacao'
    | '/ranking'
    | '/sign-out'
    | '/sorteios'
    | '/'
    | '/auth/confirmation'
    | '/auth/error'
    | '/auth/forgot-password'
    | '/auth/refresh-session'
    | '/auth/resend-confirmation'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/bonus/$uid'
    | '/convites/$code'
    | '/dev/ui-primitives'
    | '/feed/nova-publicacao'
    | '/minha-conta/$'
    | '/minha-conta/desenvolvimento'
    | '/minha-conta/networking'
    | '/minha-conta/perfil'
    | '/minha-conta/privacidade'
    | '/minha-conta/seguranca'
    | '/minha-conta/avatar'
    | '/p/$slug'
    | '/p/analytics'
    | '/p/ranking'
    | '/p/realidade-aumentada'
    | '/p/regras'
    | '/parceiros/$partnerId'
    | '/quests/$uid'
    | '/transmissoes/$liveStreamId'
    | '/feed'
    | '/jornadas'
    | '/lojinha'
    | '/minha-conta'
    | '/missoes'
    | '/objetivos'
    | '/parceiros'
    | '/quests'
    | '/quizzes'
    | '/transmissoes'
    | '/$eventSlug/quests/$uid'
    | '/guilds/$guildId/entrar'
    | '/niveis/$levelId/iniciar'
    | '/quizzes/$quizId/iniciar'
    | '/$eventSlug/jornadas'
    | '/$eventSlug/missoes'
    | '/$eventSlug/quizzes'
    | '/jornadas/$journeyId'
    | '/missoes/$missionId'
    | '/$eventSlug/quizzes/$quizId/iniciar'
    | '/$eventSlug/jornadas/$journeyId'
    | '/$eventSlug/missoes/$missionId'
    | '/jornadas/$journeyId/niveis/$levelId/iniciar'
  id:
    | '__root__'
    | '/_event'
    | '/$'
    | '/sem-evento'
    | '/_event/biblioteca'
    | '/_event/conexoes'
    | '/_event/duvidas-frequentes'
    | '/_event/extrato-de-recompensas'
    | '/_event/medalhas'
    | '/_event/meu-avatar'
    | '/_event/meu-perfil'
    | '/_event/minha-conta'
    | '/_event/programacao'
    | '/_event/ranking'
    | '/_event/sign-out'
    | '/_event/sorteios'
    | '/_event/'
    | '/_event/$eventSlug/quizzes'
    | '/_event/auth/confirmation'
    | '/_event/auth/error'
    | '/_event/auth/forgot-password'
    | '/_event/auth/refresh-session'
    | '/_event/auth/resend-confirmation'
    | '/_event/auth/reset-password'
    | '/_event/auth/sign-in'
    | '/_event/auth/sign-up'
    | '/_event/bonus/$uid'
    | '/_event/convites/$code'
    | '/_event/dev/ui-primitives'
    | '/_event/feed/nova-publicacao'
    | '/_event/minha-conta/$'
    | '/_event/minha-conta/desenvolvimento'
    | '/_event/minha-conta/networking'
    | '/_event/minha-conta/perfil'
    | '/_event/minha-conta/privacidade'
    | '/_event/minha-conta/seguranca'
    | '/_event/minha-conta_/avatar'
    | '/_event/p/$slug'
    | '/_event/p/analytics'
    | '/_event/p/ranking'
    | '/_event/p/realidade-aumentada'
    | '/_event/p/regras'
    | '/_event/parceiros/$partnerId'
    | '/_event/quests/$uid'
    | '/_event/transmissoes/$liveStreamId'
    | '/_event/feed/'
    | '/_event/jornadas/'
    | '/_event/lojinha/'
    | '/_event/minha-conta/'
    | '/_event/missoes/'
    | '/_event/objetivos/'
    | '/_event/parceiros/'
    | '/_event/quests/'
    | '/_event/quizzes/'
    | '/_event/transmissoes/'
    | '/_event/$eventSlug/quests/$uid'
    | '/_event/guilds/$guildId/entrar'
    | '/_event/niveis/$levelId/iniciar'
    | '/_event/quizzes/$quizId/iniciar'
    | '/_event/$eventSlug/jornadas/'
    | '/_event/$eventSlug/missoes/'
    | '/_event/$eventSlug/quizzes/'
    | '/_event/jornadas/$journeyId/'
    | '/_event/missoes/$missionId/'
    | '/_event/$eventSlug/quizzes/$quizId/iniciar'
    | '/_event/$eventSlug/jornadas/$journeyId/'
    | '/_event/$eventSlug/missoes/$missionId/'
    | '/_event/jornadas/$journeyId/niveis/$levelId/iniciar'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  EventRouteRoute: typeof EventRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  SemEventoRoute: typeof SemEventoRoute
}

const rootRouteChildren: RootRouteChildren = {
  EventRouteRoute: EventRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  SemEventoRoute: SemEventoRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_event",
        "/$",
        "/sem-evento"
      ]
    },
    "/_event": {
      "filePath": "_event/route.tsx",
      "children": [
        "/_event/biblioteca",
        "/_event/conexoes",
        "/_event/duvidas-frequentes",
        "/_event/extrato-de-recompensas",
        "/_event/medalhas",
        "/_event/meu-avatar",
        "/_event/meu-perfil",
        "/_event/minha-conta",
        "/_event/programacao",
        "/_event/ranking",
        "/_event/sign-out",
        "/_event/sorteios",
        "/_event/",
        "/_event/$eventSlug/quizzes",
        "/_event/auth/confirmation",
        "/_event/auth/error",
        "/_event/auth/forgot-password",
        "/_event/auth/refresh-session",
        "/_event/auth/resend-confirmation",
        "/_event/auth/reset-password",
        "/_event/auth/sign-in",
        "/_event/auth/sign-up",
        "/_event/bonus/$uid",
        "/_event/convites/$code",
        "/_event/dev/ui-primitives",
        "/_event/feed/nova-publicacao",
        "/_event/minha-conta_/avatar",
        "/_event/p/$slug",
        "/_event/p/analytics",
        "/_event/p/ranking",
        "/_event/p/realidade-aumentada",
        "/_event/p/regras",
        "/_event/parceiros/$partnerId",
        "/_event/quests/$uid",
        "/_event/transmissoes/$liveStreamId",
        "/_event/feed/",
        "/_event/jornadas/",
        "/_event/lojinha/",
        "/_event/missoes/",
        "/_event/objetivos/",
        "/_event/parceiros/",
        "/_event/quests/",
        "/_event/quizzes/",
        "/_event/transmissoes/",
        "/_event/$eventSlug/quests/$uid",
        "/_event/guilds/$guildId/entrar",
        "/_event/niveis/$levelId/iniciar",
        "/_event/quizzes/$quizId/iniciar",
        "/_event/$eventSlug/jornadas/",
        "/_event/$eventSlug/missoes/",
        "/_event/jornadas/$journeyId/",
        "/_event/missoes/$missionId/",
        "/_event/$eventSlug/jornadas/$journeyId/",
        "/_event/$eventSlug/missoes/$missionId/",
        "/_event/jornadas/$journeyId/niveis/$levelId/iniciar"
      ]
    },
    "/$": {
      "filePath": "$.tsx"
    },
    "/sem-evento": {
      "filePath": "sem-evento.tsx"
    },
    "/_event/biblioteca": {
      "filePath": "_event/biblioteca.tsx",
      "parent": "/_event"
    },
    "/_event/conexoes": {
      "filePath": "_event/conexoes.tsx",
      "parent": "/_event"
    },
    "/_event/duvidas-frequentes": {
      "filePath": "_event/duvidas-frequentes.tsx",
      "parent": "/_event"
    },
    "/_event/extrato-de-recompensas": {
      "filePath": "_event/extrato-de-recompensas.tsx",
      "parent": "/_event"
    },
    "/_event/medalhas": {
      "filePath": "_event/medalhas.tsx",
      "parent": "/_event"
    },
    "/_event/meu-avatar": {
      "filePath": "_event/meu-avatar.tsx",
      "parent": "/_event"
    },
    "/_event/meu-perfil": {
      "filePath": "_event/meu-perfil.tsx",
      "parent": "/_event"
    },
    "/_event/minha-conta": {
      "filePath": "_event/minha-conta.tsx",
      "parent": "/_event",
      "children": [
        "/_event/minha-conta/$",
        "/_event/minha-conta/desenvolvimento",
        "/_event/minha-conta/networking",
        "/_event/minha-conta/perfil",
        "/_event/minha-conta/privacidade",
        "/_event/minha-conta/seguranca",
        "/_event/minha-conta/"
      ]
    },
    "/_event/programacao": {
      "filePath": "_event/programacao.tsx",
      "parent": "/_event"
    },
    "/_event/ranking": {
      "filePath": "_event/ranking.tsx",
      "parent": "/_event"
    },
    "/_event/sign-out": {
      "filePath": "_event/sign-out.tsx",
      "parent": "/_event"
    },
    "/_event/sorteios": {
      "filePath": "_event/sorteios.tsx",
      "parent": "/_event"
    },
    "/_event/": {
      "filePath": "_event/index.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/quizzes": {
      "filePath": "_event/$eventSlug/quizzes.tsx",
      "parent": "/_event",
      "children": [
        "/_event/$eventSlug/quizzes/",
        "/_event/$eventSlug/quizzes/$quizId/iniciar"
      ]
    },
    "/_event/auth/confirmation": {
      "filePath": "_event/auth/confirmation.tsx",
      "parent": "/_event"
    },
    "/_event/auth/error": {
      "filePath": "_event/auth/error.tsx",
      "parent": "/_event"
    },
    "/_event/auth/forgot-password": {
      "filePath": "_event/auth/forgot-password.tsx",
      "parent": "/_event"
    },
    "/_event/auth/refresh-session": {
      "filePath": "_event/auth/refresh-session.tsx",
      "parent": "/_event"
    },
    "/_event/auth/resend-confirmation": {
      "filePath": "_event/auth/resend-confirmation.tsx",
      "parent": "/_event"
    },
    "/_event/auth/reset-password": {
      "filePath": "_event/auth/reset-password.tsx",
      "parent": "/_event"
    },
    "/_event/auth/sign-in": {
      "filePath": "_event/auth/sign-in.tsx",
      "parent": "/_event"
    },
    "/_event/auth/sign-up": {
      "filePath": "_event/auth/sign-up.tsx",
      "parent": "/_event"
    },
    "/_event/bonus/$uid": {
      "filePath": "_event/bonus/$uid.tsx",
      "parent": "/_event"
    },
    "/_event/convites/$code": {
      "filePath": "_event/convites/$code.tsx",
      "parent": "/_event"
    },
    "/_event/dev/ui-primitives": {
      "filePath": "_event/dev/ui-primitives.tsx",
      "parent": "/_event"
    },
    "/_event/feed/nova-publicacao": {
      "filePath": "_event/feed/nova-publicacao.tsx",
      "parent": "/_event"
    },
    "/_event/minha-conta/$": {
      "filePath": "_event/minha-conta/$.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/minha-conta/desenvolvimento": {
      "filePath": "_event/minha-conta/desenvolvimento.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/minha-conta/networking": {
      "filePath": "_event/minha-conta/networking.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/minha-conta/perfil": {
      "filePath": "_event/minha-conta/perfil.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/minha-conta/privacidade": {
      "filePath": "_event/minha-conta/privacidade.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/minha-conta/seguranca": {
      "filePath": "_event/minha-conta/seguranca.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/minha-conta_/avatar": {
      "filePath": "_event/minha-conta_.avatar.tsx",
      "parent": "/_event"
    },
    "/_event/p/$slug": {
      "filePath": "_event/p/$slug.tsx",
      "parent": "/_event"
    },
    "/_event/p/analytics": {
      "filePath": "_event/p/analytics.tsx",
      "parent": "/_event"
    },
    "/_event/p/ranking": {
      "filePath": "_event/p/ranking.tsx",
      "parent": "/_event"
    },
    "/_event/p/realidade-aumentada": {
      "filePath": "_event/p/realidade-aumentada.tsx",
      "parent": "/_event"
    },
    "/_event/p/regras": {
      "filePath": "_event/p/regras.tsx",
      "parent": "/_event"
    },
    "/_event/parceiros/$partnerId": {
      "filePath": "_event/parceiros/$partnerId.tsx",
      "parent": "/_event"
    },
    "/_event/quests/$uid": {
      "filePath": "_event/quests/$uid.tsx",
      "parent": "/_event"
    },
    "/_event/transmissoes/$liveStreamId": {
      "filePath": "_event/transmissoes/$liveStreamId.tsx",
      "parent": "/_event"
    },
    "/_event/feed/": {
      "filePath": "_event/feed/index.tsx",
      "parent": "/_event"
    },
    "/_event/jornadas/": {
      "filePath": "_event/jornadas/index.tsx",
      "parent": "/_event"
    },
    "/_event/lojinha/": {
      "filePath": "_event/lojinha/index.tsx",
      "parent": "/_event"
    },
    "/_event/minha-conta/": {
      "filePath": "_event/minha-conta/index.tsx",
      "parent": "/_event/minha-conta"
    },
    "/_event/missoes/": {
      "filePath": "_event/missoes/index.tsx",
      "parent": "/_event"
    },
    "/_event/objetivos/": {
      "filePath": "_event/objetivos/index.tsx",
      "parent": "/_event"
    },
    "/_event/parceiros/": {
      "filePath": "_event/parceiros/index.tsx",
      "parent": "/_event"
    },
    "/_event/quests/": {
      "filePath": "_event/quests/index.tsx",
      "parent": "/_event"
    },
    "/_event/quizzes/": {
      "filePath": "_event/quizzes/index.tsx",
      "parent": "/_event"
    },
    "/_event/transmissoes/": {
      "filePath": "_event/transmissoes/index.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/quests/$uid": {
      "filePath": "_event/$eventSlug/quests/$uid.tsx",
      "parent": "/_event"
    },
    "/_event/guilds/$guildId/entrar": {
      "filePath": "_event/guilds/$guildId/entrar.tsx",
      "parent": "/_event"
    },
    "/_event/niveis/$levelId/iniciar": {
      "filePath": "_event/niveis/$levelId/iniciar.tsx",
      "parent": "/_event"
    },
    "/_event/quizzes/$quizId/iniciar": {
      "filePath": "_event/quizzes/$quizId/iniciar.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/jornadas/": {
      "filePath": "_event/$eventSlug/jornadas/index.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/missoes/": {
      "filePath": "_event/$eventSlug/missoes/index.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/quizzes/": {
      "filePath": "_event/$eventSlug/quizzes/index.tsx",
      "parent": "/_event/$eventSlug/quizzes"
    },
    "/_event/jornadas/$journeyId/": {
      "filePath": "_event/jornadas/$journeyId/index.tsx",
      "parent": "/_event"
    },
    "/_event/missoes/$missionId/": {
      "filePath": "_event/missoes/$missionId/index.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/quizzes/$quizId/iniciar": {
      "filePath": "_event/$eventSlug/quizzes/$quizId/iniciar.tsx",
      "parent": "/_event/$eventSlug/quizzes"
    },
    "/_event/$eventSlug/jornadas/$journeyId/": {
      "filePath": "_event/$eventSlug/jornadas/$journeyId/index.tsx",
      "parent": "/_event"
    },
    "/_event/$eventSlug/missoes/$missionId/": {
      "filePath": "_event/$eventSlug/missoes/$missionId/index.tsx",
      "parent": "/_event"
    },
    "/_event/jornadas/$journeyId/niveis/$levelId/iniciar": {
      "filePath": "_event/jornadas/$journeyId/niveis/$levelId/iniciar.tsx",
      "parent": "/_event"
    }
  }
}
ROUTE_MANIFEST_END */
